var map = {
	"./bkg.png": "f56c",
	"./cl1.png": "1f53",
	"./cl2.png": "f7da",
	"./cl2_1.png": "f7ef",
	"./cl2_2.png": "aa55",
	"./cl2_3.png": "9340",
	"./cr1.png": "3385",
	"./cr1_1.png": "14a8",
	"./cr1_2.png": "4828",
	"./cr1_3.png": "d96e",
	"./cr1_4.png": "0d74",
	"./cr2.png": "3292",
	"./cr2_1.png": "ec5a",
	"./cr2_2.png": "2552",
	"./cr2_3.png": "3f02",
	"./cr3.png": "360f",
	"./frg.png": "5bc3",
	"./tagline.png": "091a",
	"./tagline/1.png": "00f5",
	"./tagline/2.png": "a66f",
	"./tagline/3.png": "3e17"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6171";